import React from "react";

import { Modal } from "@material-ui/core";

import { isFIT_1_AnamolyType } from "utils/utils";
import { valueStrings } from "constants/constantStrings";

import DupontIconButton from "components/DupontIconButton";

import CancelIcon from "assets/SvgIcon/Cancel";

import { getFIT_1_TimeSeriesConfig, getFIT_2_TimeSeriesConfig } from "./smartInsight.timseries.config";
import SmartInsightCard from "./smartInsightCard";
import SmartInsightTimeSeriesData from "./SmartInsightTimeSeries";

const SmartInsightPopup = ({ value, open, handleClose, type }) => {
  const timeSeries = isFIT_1_AnamolyType(type) ? getFIT_1_TimeSeriesConfig : getFIT_2_TimeSeriesConfig;

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition style={{ zIndex: 99999 }}>
      <div className="insight-card-popup">
        <div className="d-flex">
          <div className="insight-card-container insight_card">
            <SmartInsightCard value={value} isToShowIcon={false} />
          </div>
          <div className="divider" />
          <div className="time_series">
            {timeSeries.map(item => (
              <SmartInsightTimeSeriesData title={item.title} color={item.color} tagId={item.tagId} key={item.tagId} endTime={value.CycleEndTime} />
            ))}
          </div>
          <DupontIconButton onClick={handleClose} tooltip={valueStrings.close}>
            <CancelIcon />
          </DupontIconButton>
        </div>
      </div>
    </Modal>
  );
};

export default SmartInsightPopup;
